<div class="deposit-new-check-in">
  <section>
    <info-page-header label="Pago de Fianza"></info-page-header>
    <div class="deposit-new-check-in-content">
      <p class="text-check">
        Para acceder a la vivienda, se requiere un depósito por daños. Preautorizaremos el depósito estipulado en su tarjeta, que se desbloqueará después de su estancia. Por favor, seleccione a la persona responsable de este depósito de la siguiente lista:

      </p>

      <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <div class="form__field">
          <label for="nombre">Nombre</label>
          <input id="nombre" type="text" formControlName="nombre" translate="no" data-wg-notranslate />
        </div>

        <div class="form__field">
          <label for="apellido1">Apellido 1</label>
          <input id="apellido1" type="text" formControlName="apellido1" translate="no" data-wg-notranslate />
        </div>



        <div class="form__field">
          <label for="nacionalidad">Tipo Nacionalidad</label>
          <select id="nacionalidad" formControlName="nacionalidad">
            <option value="DNI">Español</option>
            <option value="NIE">Italiano</option>
            <option value="PASAPORTE">Francés</option>
          </select>
        </div>

        <div class="form__field">
          <label for="email">Email</label>
          <input id="email" type="email" formControlName="email" translate="no" data-wg-notranslate />
        </div>



        <!-- Botón principal -->
        <button
          type="submit"
          class="primary-btn"
          [disabled]="form.invalid"
        >
          Pagar
        </button>
      </form>
    </div>
  </section>
</div>
